 import React from 'react'
export const Context = React.createContext( ['' , () => {}])
 
export const PageConsumer = Context.Consumer
export const PageProvider = Context.Provider
